import React, { useEffect } from 'react';
import { useWatch, Control, UseFormClearErrors } from 'react-hook-form';

interface FormObject {
	form: any[];
}

interface AutoClearFormErrorsProps<T extends FormObject> {
	control: Control<T>;
	clearErrors: UseFormClearErrors<T>;
}

const AutoClearFormErrors = <T extends FormObject>({ control, clearErrors }: AutoClearFormErrorsProps<T>) => {
	const formValues = useWatch({ control }) as T;

	useEffect(() => {
		if (formValues?.form) {
			formValues.form.forEach((field: any, index: number) => {
				// Sprawdź czy pole ma wartość
				const hasValue =
					field.value !== undefined &&
					field.value !== null &&
					field.value !== '' &&
					(typeof field.value !== 'string' || field.value.trim() !== '');

				const hasOptions = Array.isArray(field.moptions) && field.moptions.length > 0;

				const hasGroupOptions = Array.isArray(field.mgoptions) && field.mgoptions.length > 0;

				const hasFileValue = typeof field.url === 'string' && field.url !== '';

				if (hasValue || hasFileValue) {
					clearErrors(`form.${index}.value` as any);
				}

				if (hasOptions) {
					clearErrors(`form.${index}.moptions` as any);
				}

				if (hasGroupOptions) {
					clearErrors(`form.${index}.mgoptions` as any);
				}
			});
		}
	}, [formValues, clearErrors]);

	return null;
};

export default AutoClearFormErrors;
